import React from 'react';

// @deprecated to use, instead use useSitecoreContext
export var SitecoreContextReactContext = /*#__PURE__*/React.createContext({});
export function useSitecoreContext() {
  var context = React.useContext(SitecoreContextReactContext);
  if (context === undefined) {
    throw new Error('useSitecoreContext must be used within a SitecoreContextReactContext Provider');
  }
  return context;
}